import { useLocalStore } from 'mobx-react';
import { meeting as meetingModel } from '@/models';
import { useTimeout } from 'ahooks';
import { HandUpStatus } from '../../component/EmoJ';
import { message } from '@/components';
import { useIntl } from 'umi';

interface DeviceItem {
  memberUid: string; //举手的参会人 ID
  memberDeviceId: string; //举手的参会设备 ID
  memberYxMeetingUid: string;
}

enum reasonType {
  selfHandDown = 1,
  hostHandDown = 2,
}
export interface handupChangeData {
  channelId: number;
  devices: Array<DeviceItem>;
  timestamp: number;
  reason: reasonType; //1-自己手放下，2-主持操作手放下
  memberUid: string; //举手的参会人 ID
  memberDeviceId: string; //举手的参会设备 ID
  memberYxMeetingUid: string;
}

export default function useAppsStateChange() {
  const { meeting } = useLocalStore(() => {
    return {
      meeting: meetingModel,
    };
  });
  const { formatMessage } = useIntl();

  const change = async (body: handupChangeData, handupStatus: HandUpStatus) => {
    console.log('----body', body);

    if (handupStatus === HandUpStatus.on) {
      meeting?.updateRectionMap(body.memberYxMeetingUid, {
        memberUid: body.memberYxMeetingUid,
        timestamp: Date.now(),
        isHandup: handupStatus,
      });
      meeting?.updateMemberHandUpStatusYxuids([body.memberYxMeetingUid], handupStatus);
      return;
    }
    const devices = body.devices;
    devices.map((item: DeviceItem) => {
      meeting?.updateRectionMap(item.memberYxMeetingUid, {
        memberUid: item.memberYxMeetingUid,
        timestamp: Date.now(),
        isHandup: handupStatus,
      });
      meeting?.updateMemberHandUpStatusYxuids([item.memberYxMeetingUid], handupStatus);
    });
    if (body?.reason === reasonType.hostHandDown) {
      message.info({
        content: formatMessage({ id: 'cancelledYourRaiseOfHand' }),
        noIcon: true,
      });
    }
  };
  return change;
}
